import type { SVGProps } from "react";
export interface ShapeCircleDashIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ShapeCircleDashIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ShapeCircleDashIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M8.942 21.59c.12-.61.713-1.006 1.323-.886a8.9 8.9 0 0 0 3.461.002l.114-.016a1.125 1.125 0 0 1 .321 2.223l-.537.093c-1.26.185-2.546.154-3.797-.094a1.126 1.126 0 0 1-.885-1.323Zm-4.324-4.662a8.9 8.9 0 0 0 2.09 2.197l.356.252.092.07a1.125 1.125 0 0 1-1.246 1.858l-.1-.06-.445-.315a11.2 11.2 0 0 1-2.618-2.75zm14.833-.092a1.126 1.126 0 0 1 1.802 1.343l-.316.447a11.2 11.2 0 0 1-2.748 2.619l-.1.06a1.126 1.126 0 0 1-1.153-1.928l.355-.252a8.9 8.9 0 0 0 2.09-2.197zm-16.393-.217a1.125 1.125 0 0 1 1.56.31l-1.87 1.25a1.125 1.125 0 0 1 .31-1.56m-1.972-6.78a1.125 1.125 0 0 1 2.207.434 9 9 0 0 0-.073 3.033l.075.429.018.114a1.126 1.126 0 0 1-2.196.435l-.028-.111-.094-.538a11.2 11.2 0 0 1 .091-3.797Zm21.826-.012c.284 1.43.284 2.904.002 4.334l-.028.111a1.125 1.125 0 0 1-2.18-.546l.075-.43a8.9 8.9 0 0 0-.076-3.031l1.103-.219zm-1.323-.885a1.125 1.125 0 0 1 1.323.885l-2.207.438a1.125 1.125 0 0 1 .884-1.323M5.81 2.754a1.126 1.126 0 0 1 1.254 1.87A8.9 8.9 0 0 0 4.618 7.07a1.125 1.125 0 1 1-1.87-1.25A11.2 11.2 0 0 1 5.81 2.753Zm10.818.308a1.125 1.125 0 0 1 1.462-.366l.1.058.445.315c.876.652 1.652 1.43 2.302 2.306l.316.445.058.1a1.125 1.125 0 0 1-1.86 1.243l-.07-.092-.25-.356c-.52-.7-1.14-1.32-1.84-1.841l-.355-.25-.093-.07a1.126 1.126 0 0 1-.215-1.492m-6.79-1.976a11.2 11.2 0 0 1 3.797-.091l.538.094.111.028a1.125 1.125 0 0 1-.435 2.195l-.114-.017-.43-.075a9 9 0 0 0-3.031.073l-.217-1.104zm.436 2.207a1.125 1.125 0 0 1-.436-2.207z"
      />
    </svg>
  );
}
